import React from 'react'
import {
  FiAward,
  FiCompass,
  FiCpu,
  FiTrendingUp,
  FiUsers
} from 'react-icons/fi';
import CardRow from './Card/CardRow'

function WhyUs() {
  const data=[
    {
      moto:"Партнерская поддержка",
      icon:FiUsers,
      desc:"Мы предлагаем своим партнёрам профессиональную, техническую и информационную поддержку на всех стадиях работ"
    },
    {
      moto:"Всесторонний опыт в добыче",
      icon:FiCpu,
      desc:"Благодаря практическому опыту и технической грамотности мы гарантируем надежное качество проектов"
    },
    {
      moto:"Повышение эффективности и производительности",
      icon:FiTrendingUp,
      desc:"Наши решения помогут вам достигнуть нового уровня эффективности и производительности"
    },
    {
      moto:"Непрерывное обучение и отслеживание новых продукты для разработки",
      icon:FiAward,
      desc:"Мы предлагаем широкие компетенции в сфере горных работ и безопасности в горном деле"
    },
    {
      moto:"Выбор самых оптимальных решений",
      icon:FiCompass,
      desc:"Мы продаем не оборудование, мы продаем решение проблем партнера и помогаем реализовать новые возможности"
    }
  ]
  return (
    <section className="why-us-section">
        <CardRow data={data} class="why-us"/>
    </section>
  )
}

export default WhyUs
